<div id="vue-footer">
  <div class="vue-container">
    <p>
      <span><a href="https://www.vue.gov.co/" target="_blank">VUE - VENTANILLA ÚNICA EMPRESARIAL</a> |</span>
      <a [href]="'UrlCamara' | templateText" target="_blank">{{ 'NombreCamara' | templateText | uppercase }}</a>
    </p>
     <p>
       © 2022 Todos los derechos reservados
     </p>
  </div>
</div>
